import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  ThemeProvider,
  Typography,
  createTheme,
  Box,
} from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const StartGuideDialog = ({ startGuide }) => {
  const [open, setOpen] = useState(true);

  // Function to request microphone access
  const handleStartGuide = async () => {
    try {
      startGuide && startGuide();
      setOpen(false);
    } catch (error) {
      console.error("Error starting guide:", error);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "center", // Positions the dialog closer to the bottom
          },
        }}
        PaperProps={{
          style: {
            width: "400px", // Reduced width
            margin: "150px",
          },
        }}
      >
        <DialogTitle>Ready to start?</DialogTitle>
        <DialogContent>
          <Typography>
            Begin your experience - make sure to turn up your audio to hear the Guide. To navigate, zoom in and out using your scroll wheel or trackpad.
          </Typography>
          <Box mt={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleStartGuide}
            >
              Start Guide
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

     
    </ThemeProvider>
  );
};

export default StartGuideDialog;
